import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import { definePreset } from "@primeuix/themes";
import App from "./app/App.vue";
import { router } from "./app/router";
import { i18n } from "./app/i18n";
import "@fontsource-variable/dm-sans";
import "@fontsource-variable/manrope";
import "primeicons/primeicons.css";
import "./styles/main.css";
const preset = definePreset(Aura, {
  components: {
    button: {
      root: {
        primary: {
          background: "#ffc83d",
          hoverBackground: "#f5b924",
          activeBackground: "#eaaa13",
          borderColor: "#ffc83d",
          hoverBorderColor: "#f5b924",
          activeBorderColor: "#eaaa13",
          color: "#18354c",
          hoverColor: "#18354c",
          activeColor: "#18354c",
          focusRing: { color: "#28567f", shadow: "none" },
        },
      },
    },
  },
  semantic: {
    primary: {
      50: "#eef6fc",
      100: "#d9eafa",
      200: "#bad9f0",
      300: "#8fc0e5",
      400: "#5f9ece",
      500: "#3c7eb7",
      600: "#306a9d",
      700: "#28567f",
      800: "#254967",
      900: "#223e57",
      950: "#142839",
    },
  },
});
createApp(App)
  .use(createPinia())
  .use(i18n)
  .use(PrimeVue, {
    theme: { preset, options: { darkModeSelector: ".hello-dark" } },
  })
  .use(router)
  .mount("#app");
